import LoadingState from '@/api/LoadingState';
import ACTIONS from '@/store/storeActions';
import ExerciseDocumentsRestModel from '@/api/RestModels/exerciseDocuments';

export default class ExerciseDocuments {
  constructor(store) {
    this.$store = store;
  }

  async getDocumentNames(exerciseId) {
    const self = this;
    self.$store.dispatch(ACTIONS.SET_CURRENT_EXERCISE_DOCUMENTS_LOADING_STATE, LoadingState.LOADING);
    try {
      const data = await ExerciseDocumentsRestModel.getDocumentNames(exerciseId);
      self.$store.dispatch(ACTIONS.SET_CURRENT_EXERCISE_DOCUMENTS, { id: exerciseId, documentNames: data });
      self.$store.dispatch(ACTIONS.SET_CURRENT_EXERCISE_DOCUMENTS_LOADING_STATE, LoadingState.LOADED);
    } catch (err) {
      self.$store.dispatch(ACTIONS.SET_CURRENT_EXERCISE_DOCUMENTS_LOADING_STATE, LoadingState.FAILED);
    }
  }

  async getDocument(path) {
    const self = this;
    try {
      const data = await ExerciseDocumentsRestModel.getDocument(path);
      return data;
    } catch (err) {
      return err;
    }
  }
}
